// src/posts/index.js
export const posts = [
    {
        author: 'Leitz',
        date: '2021-05-27',
        title: 'Stop messing with tar and switch to atool',
        description: 'No need to memorize how to use different archive tools. atool rules them all.',
        slug: 'atool-rules-them-all',
        path: 'atool-rules-them-all/content.md',
    },
    {
        author: 'Leitz',
        date: '2024-12-03',
        title: 'Make parsing your bash script inputs easier with shflags',
        description: 'Bash scripting is an esoteric practice that\'s more like black magic than a programmer\'s tool. Parsing inputs is a tedious process unless you use a tool like shflags. Here\'s how to do it.',
        slug: 'bash-swipe-shflags',
        path: 'bash-swipe-shflags/content.md',
    },
    {
        author: 'Leitz',
        date: '2018-07-04',
        title: 'Custom Spring Annotations',
        description: 'Elevate your custom Java annotations to functional masterpieces. This example shows you the way!',
        slug: 'behavioral-annotations',
        path: 'behavioral-annotations/content.md',
    },
    {
        author: 'Leitz',
        date: '2023-07-09',
        title: 'A Christmas Story that really happened',
        description: 'The true story of a blue collar Christmas vs a white collar Christmas.',
        slug: 'christmas',
        path: 'christmas/content.md',
    },
    {
        author: 'Leitz',
        date: '2019-02-11',
        title: 'Database Performance - Datatypes',
        description: 'Supercharge your relational database performance by understanding how to pick perfect datatypes. Impress your colleagues with these relational database secrets!',
        slug: 'database-performance-datatypes',
        path: 'database-performance-datatypes/content.md',
    },
    {
        author: 'Leitz',
        date: '2018-05-31',
        title: 'Decompile Java class files from the command line',
        description: 'There are times developers need to view Java source code when they don\'t have the .java source file.Perhaps they only have the.class file or a .jar file full of .class files.',
        slug: 'decompile-java-class-files',
        path: 'decompile-java-class-files/content.md',
    },
    {
        author: 'Leitz',
        date: '2024-06-09',
        title: 'Do you have a Boomer Manager?',
        description: 'Test your boss and see if he is a Boomer Manager. Great for determining if you should quit your job.',
        slug: 'do-you-have-a-boomer-manager',
        path: 'do-you-have-a-boomer-manager/content.md',
    },
    {
        author: 'Leitz',
        date: '2021-06-10',
        title: 'Everything is going to be amazing',
        description: 'The 20th century\'s centralization of all institutions is breaking and the age of decentralization is here.It\'s amazing.',
        slug: 'everything-is-amazing',
        path: 'everything-is-amazing/content.md',
    },
    {
        author: 'Leitz',
        date: '2024-12-23',
        title: 'What are first principles?',
        description: 'What are first principles and domain? Why are they important to know? Spoiler: If you know the first principles of a domain, people will think you\'re a wizard.',
        slug: 'first-principles-definition',
        path: 'first-principles-definition/content.md',
    },
    {
        author: 'Leitz',
        date: '2025-01-01',
        title: 'The First Principles of Management',
        description: 'There are many terrible managers because they lack the fundamentals. If you know the first principles of management you will be 10x the manager you are today.',
        slug: 'first-principles-management',
        path: 'first-principles-management/content.md',
    },
    {
        author: 'Leitz',
        date: '2023-06-07',
        title: 'A FIST FIGHT happened during a multimillion dollar software implementation',
        description: 'The true story of how a fist fight happened during a multimillion dollar software implementation. And I was there.',
        slug: 'fist-fight',
        path: 'fist-fight/content.md',
    },
    {
        author: 'Leitz',
        date: '2019-07-20',
        title: 'Kubernetes Basics',
        description: 'Learn the basics of Kubernetes. The platform that\'s transformed the modern software landscape forever!',
        slug: 'kubernetes-basics',
        path: 'kubernetes-basics/content.md',
    },
    {
        author: 'Leitz',
        date: '2024-08-17',
        title: 'How to use logging in your Bash scripts',
        description: 'Create a small logging framework in your Bash scripts to help with output.',
        slug: 'logging-in-bash-scripts',
        path: 'logging-in-bash-scripts/content.md',
    },
    {
        author: 'Leitz',
        date: '2021-05-14',
        title: 'McDonald\'s is the 8th wonder of the modern world',
        description: 'If you went back in time and told someone in 1810 about the future, they wouldn\'t believe you when you described McDonald\'s.',
        slug: 'mcdonalds-8th-wonder-of-the-world',
        path: 'mcdonalds-8th-wonder-of-the-world/content.md',
    },
    {
        author: 'Leitz',
        date: '2019-10-13',
        title: 'The Price of Productivity',
        description: 'Stop being afraid of paying for software and technical education. Get in the game and dramatically improve your skills and output by smartly spending money.',
        slug: 'price-of-productivity',
        path: 'price-of-productivity/content.md',
    },
    {
        author: 'Leitz',
        date: '2024-09-15',
        title: 'Start using SQL statements in your Java code',
        description: 'You don\'t need to use ORM technologies like Hibernate for every project . Using SQL statements gives you more control over tuning and is a straight forward implementation.',
        slug: 'sql-statement-builder',
        path: 'sql-statement-builder/content.md',
    },
    {
        author: 'Leitz',
        date: '2019-11-21',
        title: 'Tmux the Terminal Emulator',
        description: 'Use the boutique software application Tmux to maximize your terminal usage. It\'s free and can change your terminal productivity for ever!Demo included.',
        slug: 'tmux-the-terminal-emulator',
        path: 'tmux-the-terminal-emulator/content.md',
    },
    {
        author: 'Leitz',
        date: '2019-05-19',
        title: 'Your Tech Interview Sucks - part 1',
        description: 'Supercharge your development team by improving your interview process. Part 1 of 2.',
        slug: 'your-tech-interview-sucks-part-1',
        path: 'your-tech-interview-sucks-part-1/content.md',
    },
    {
        author: 'Leitz',
        date: '2019-05-26',
        title: 'Your Tech Interview Sucks - part 2',
        description: 'Supercharge your development team by improving your interview process. Part 2 of 2.',
        slug: 'your-tech-interview-sucks-part-2',
        path: 'your-tech-interview-sucks-part-2/content.md',
    },
];

export const recentPosts = posts
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, 5);
